
    import Component from "vue-class-component";
    import {
        factory,
        QualificationActions,
        QualificationsClient,
        TrainingQualificationModel,
        TrainingQualificationOptions
    } from "@/api-client";
    import {QualificationAddBase} from "@/features/documents/qualifications/views/QualificationAddBase";
    import FormLayout from "@/features/personProfile/components/FormLayout.vue";
    import {Prop} from "vue-property-decorator";
    import {NavigationGuardNext} from "vue-router/types/router";
    import TrainingQualificationUpsertForm from "@/features/documents/qualifications/components/TrainingQualificationUpsertForm.vue";

    interface Props {
        seafarerId: string;
        qualificationPreloadedActions: QualificationActions;
        options: TrainingQualificationOptions;
    }

    @Component({
        components: {
            TrainingQualificationUpsertForm,
            FormLayout
        },
        async beforeRouteEnter(to, from, next : NavigationGuardNext<TrainingQualificationAdd>) {
            const props = to.meta!.props as Props;
            props.seafarerId = to.params.seafarerId;
            Promise.all([
                new QualificationsClient().availableActions(props.seafarerId, null),
                new QualificationsClient().trainingOptions()
            ]).then(values => {
                props.qualificationPreloadedActions = values[0];
                props.options = values[1];
                next();
            }).catch(e => next(e))
        }
    })
    export default class TrainingQualificationAdd extends QualificationAddBase<TrainingQualificationModel> implements Props {
        @Prop({ required: true })
        qualificationPreloadedActions!: QualificationActions;

        @Prop({ required: true })
        options!: TrainingQualificationOptions;

        initialModel: TrainingQualificationModel = factory.create(TrainingQualificationModel);

        async submitQualification(model: TrainingQualificationModel) {
            return await this.submit(model);
        }
    }
